import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { HeroSection } from './HeroSection'
import { MediterraneanDietSection } from './MediterraneanDietSection'
import { NutritionalValuesSection } from './NutritionalValuesSection'
import { CertificationsSection } from './CertificationsSection'
import { FoodSafetySection } from './FoodSafetySection'

export function NutritionPage() {
  const { t } = useTranslation('common')

  return (
    <>
      <SEO
        title={t('nav.nutrition')}
        description={t('nutrition.metaDescription')}
        type="website"
      />

      <HeroSection />
      <MediterraneanDietSection />
      <NutritionalValuesSection />
      <CertificationsSection />
      <FoodSafetySection />
    </>
  )
}
